import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import AdminAddItinerary from "./AdminAddItinerary";

const AdminEventItinerary = ({ match, event, ...props }) => {

    const [response, setResponse] = useState([]);
    const [waves, setWaves] = useState([]);
    const [packages, setPackages] = useState([]);

    const [filter, setFilter] = useState({
        wave_id: 0,
        package_id: 0,
    });

    const loadData = () => {
        adminHttp
            .get('/events/' + event.id + '/itineraries?' + new URLSearchParams(filter).toString())
            .then(res => setResponse(res.data));
    };

    const loadWaves = () => {
        adminHttp
            .get('/events/' + event.id + '/waves',)
            .then(res => setWaves(res.data));
    };

    const loadPackages = () => {
        adminHttp
            .get('/events/' + event.id + '/packages',)
            .then(res => setPackages(res.data));
    };

    useEffect(loadWaves, []);
    useEffect(loadPackages, []);
    useEffect(loadData, [filter, event]);


    const handleFilter = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let filterData = { ...filter, [name]: value };

        setFilter(filterData);
    };

    return (

        <div className="admin-inventory">
            <div className="row">
                <div className="col-8">
                    <h2>Itinerary Documents</h2>
                </div>
                <div className="col-4 text-right">
                    <AdminAddItinerary className="btn btn-primary btn-sm" onChange={loadData} >+ Add Itinerary Documents</AdminAddItinerary>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card shadow-sm bg-white">
                        <div className="row pt-2 pb-2">
                            <div className="col-2">
                                <label className="mt-2 ml-4 text-muted">FILTER ITINERARY</label>
                            </div>
                            <div className="col-2">
                                <select name="wave_id"
                                    defaultValue={filter.wave_id}
                                    onChange={e => handleFilter(e)}
                                    className="form-control">

                                    <option value={0}>Wave</option>

                                    {waves.map(wave => (
                                        <option key={wave.id} value={wave.id}>{wave.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-2">
                                <select name="package_id"
                                    defaultValue={filter.package_id}
                                    onChange={e => handleFilter(e)}
                                    className="form-control">

                                    <option value={0}>Package</option>

                                    {packages.map(p => (
                                        <option key={p.id} value={p.id}>{p.name} {p.id}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <table className="table">

                                <thead>
                                    <tr>
                                        <th scope="col">Wave</th>
                                        <th scope="col">Package</th>
                                        <th scope="col">Document Name</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {response.map(r => (
                                        <tr key={r.id}>
                                            <td>{r.wave?.name || '-'}</td>
                                            <td>{r.package?.name || '-'}</td>
                                            <td>{r.document?.name || '-'}</td>
                                            <td>
                                                <AdminAddItinerary className="btn btn-primary btn-sm" itinerary={r} onChange={loadData} >Edit Itinerary Documents</AdminAddItinerary>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventItinerary);
